module.exports = __webpack_public_path__ + "img/hyll-logo.9b7f4d08.svg";